import React, {PureComponent} from 'react';
import {withTranslation} from 'react-i18next';
import Loading from '../subComponents/GenericLoading/loading';
import LayoutComponent, {onSectionSelected} from "./layout/layout";
import Layout1 from '../../assets/layout_1.png'
import Layout2 from '../../assets/layout_2.png'
import Connect from "react-redux/es/connect/connect";
import './index.css'
import {alertSuccess, editLayout, getArticles, getLayouts} from "../../actions";
import {
	changeKeyValueInLayout,
	dispatchOnPresentationEditLayout,
	dispatchOnPresentationEditLayoutFailure,
	dispatchOnPresentationEditLayoutSuccess,
	dispatchOnPresentationGetLayouts,
	dispatchOnPresentationGetLayoutsFailure,
	dispatchOnPresentationGetLayoutsSuccess,
	dispatchOnPresentationHasArticlesChanged,
	dispatchOnPresentationLayoutChanged,
	dispatchOnPresentationSectionEditingChanged,
	dispatchOnPresentationSectionSelectedChanged,
	dispatchOnPresentationSelectingPropChanged,
	doesLayoutHaveChages
} from "./functions";
import SelectArticlesModal from "../modals/articles/selectArticlesModal";
import {debug, find} from "../../utility/functions";

class Presentation extends PureComponent {

	componentDidMount(): void {
		this.getLayouts();
		this.onGetArticles()
	}

	getLayouts = () => {
		this.props.dispatchOnPresentationGetLayouts();
		getLayouts()
			.then((request) => {
				debug("request", request);
				this.props.dispatchOnPresentationGetLayoutsSuccess(request);
			})
			.catch((error) => {
				this.props.dispatchOnPresentationGetLayoutsFailure();
			})

	};

	onGetArticles = () => {
		getArticles()
			.then(response => {
				debug("response", response);
				this.props.dispatchOnPresentationHasArticlesChanged(response.data.length > 0)
			})
	};

	editLayout = () => {
		const {newLayout, saving} = this.props;
		if (!newLayout || saving) return null;
		this.props.dispatchOnPresentationEditLayout();
		editLayout(newLayout)
			.then((response) => {
				alertSuccess(response.message);
				this.props.dispatchOnPresentationEditLayoutSuccess(newLayout);
			})
			.catch((error) => {
				this.props.dispatchOnPresentationEditLayoutFailure();
			})

	};

	onCancelLayoutChanges = () => {
		this.props.dispatchOnPresentationLayoutChanged(this.props.layout)
	};

	hideSelectedModal = () => {
		this.props.dispatchOnPresentationSelectingPropChanged(false);
	};

	renderEditLayoutModal() {
		const {selecting, newLayout, selectedSection} = this.props;
		if (!newLayout) return null;
		if (selecting) {
			return (
				<SelectArticlesModal
					title={this.props.headerName}
					existingArticles={[...newLayout[selectedSection]]}
					onModalClosed={() => {
						this.hideSelectedModal()
					}}
					onPositiveActionButtonPressed={(articles) => {
						const layout = {
							...newLayout,
							[selectedSection]: [...articles]
						};
						this.props.dispatchOnPresentationLayoutChanged(layout);
						if (articles.length > 0) {
							onSectionSelected(this.props.headerName, this.props.headerIndex, true);
						}
						this.hideSelectedModal();
					}}
				/>
			)
		}
	}

	onLayoutSelected = (l) => {
		const {newLayout} = this.props;
		if (!newLayout) return null;
		if (newLayout.layout.id === l.id) return;
		const layout = changeKeyValueInLayout(newLayout, 'layout', l);
		if (layout) this.props.dispatchOnPresentationLayoutChanged(layout)

	};

	renderSaveButton() {
		const {layout, newLayout, saving} = this.props;
		if (!layout || !newLayout) return null;
		if (doesLayoutHaveChages(layout, newLayout)) {
			return (
				<button
					className='btn btn-primary presentation-content-action-button'
					type={'button'}
					onClick={this.editLayout}
				>
					{saving ? <Loading color={"white"} size={"small-spinner"}/> : "Guardar"}
				</button>
			)
		}
	}

	renderCancelButton() {
		const {layout, newLayout, t} = this.props;
		if (!layout || !newLayout) return null;
		if (doesLayoutHaveChages(layout, newLayout)) {
			return (
				<button
					className='btn btn-dark presentation-content-action-button'
					type={'button'}
					onClick={this.onCancelLayoutChanges}
				>
					{t("Cancel")}
				</button>
			)
		}
	}

	renderLayoutsCheckBoxes() {
		const {layouts, newLayout} = this.props;

		if (!layouts) return null;

		return layouts.map((layout, i) => {

			const selected = newLayout.layout.id === layout.id;

			return (
				<div key={"layout-image-" + layout.id} className='img-presentation-layout'>
					<img
						className={selected? 'img-presentation-layout-selected' : null}
						width={300}
						src={i === 0? Layout1 : Layout2}
						alt={""}
						onClick={() => {
							this.onLayoutSelected(layout)
						}}
					/>
				</div>
			)
		})
	}

	renderLayout() {
		const {newLayout} = this.props;
		if (!newLayout) return null;
		return (
			<LayoutComponent/>
		)
	}

	renderContent() {
		const {t} = this.props;
		return (
			<div className="container-presentation-body-left-layout">
				{this.renderLayout()}
				<div className='div-presentation-actions'>
					{this.renderSaveButton()}
					{this.renderCancelButton()}
				</div>
			</div>
		)
	}

	renderEmptyContentText() {
		const {hasArticles} = this.props;
		if (!hasArticles) {
			return (
				<div className="container-presentation-body-right-layout">
					<h5>Não existem artigos associados com a tua escola</h5>
					<h6>Por favor vai à página dos artigos e cria um</h6>
				</div>
			)
		} else {
			return(
				<div className="presentation-actions-container">
					{this.renderLayoutsCheckBoxes()}
				</div>
			)
		}
	}

	renderBody = () => {
		const {loading} = this.props;

		if(loading) {
			return (
				<div className='presentation-container-body'>
					<Loading className={'presentation-loading'} color={"blue"} size={"medium-spinner"}/>
				</div>
			);
		}

		return(
			<div className="container-presentation-body">
				{this.renderContent()}
				<div className="container-presentation-body-division">
				</div>
				{this.renderEmptyContentText()}
			</div>
		)
	};

	render() {
		const {t} = this.props;

		return (
			<div className={'presentation-container'}>
				<div className="container-news-header">
					<div className="container-news-header-tittle"><h2>{t('Layouts')}</h2></div>
				</div>
				{this.renderBody()}
				{this.renderEditLayoutModal()}
			</div>
		);
	}
}

const mapStateToProps = store => ({
	selecting: store.presentationReducer.selecting,
	loading: store.presentationReducer.loading,
	saving: store.presentationReducer.saving,
	layouts: store.presentationReducer.layouts,
	layout: store.presentationReducer.layout,
	newLayout: store.presentationReducer.newLayout,
	selectedSection: store.presentationReducer.selectedSection,
	hasArticles: store.presentationReducer.hasArticles,
	headerName: store.presentationReducer.headerName,
	headerIndex: store.presentationReducer.headerIndex,
});


const mapFunctionsToProps = {
	dispatchOnPresentationGetLayouts,
	dispatchOnPresentationGetLayoutsFailure,
	dispatchOnPresentationGetLayoutsSuccess,
	dispatchOnPresentationEditLayout,
	dispatchOnPresentationEditLayoutFailure,
	dispatchOnPresentationEditLayoutSuccess,
	dispatchOnPresentationLayoutChanged,
	dispatchOnPresentationSelectingPropChanged,
	dispatchOnPresentationSectionEditingChanged,
	dispatchOnPresentationSectionSelectedChanged,
	dispatchOnPresentationHasArticlesChanged,
};

export default Connect(mapStateToProps, mapFunctionsToProps)(withTranslation("translations")(Presentation));
